import { cx } from '@linaria/core';
import { CheckmarkIcon } from '@ui/kit';
import { useComponentEntry } from '@utils/component-framework';
import { list, button, modifiers } from './steps.style.js';
import { jsx } from 'react/jsx-runtime';
import { useUpdateLocationMutation } from '../../state/mutation.update-location.js';

function Steps(props) {
  const entry = useComponentEntry(props.entryKey);
  const updateLocation = useUpdateLocationMutation(props.entryKey);
  const handleGoToIndex = index => {
    updateLocation(index);
    props.pagination.goTo(index);
  };
  return /*#__PURE__*/jsx("ul", {
    className: list,
    children: props.cards.map((_, index) => {
      return /*#__PURE__*/jsx("li", {
        children: /*#__PURE__*/jsx("button", {
          className: cx(button, index === props.pagination.activeItemIndex && modifiers.active.className),
          onClick: () => handleGoToIndex(index),
          children: entry.data?.data.cards[index]?.flipped && /*#__PURE__*/jsx(CheckmarkIcon, {
            height: 7
          })
        })
      }, index);
    })
  });
}

export { Steps };
//# sourceMappingURL=steps.js.map
